import React from "react";

interface FormRangeValuesProps {
    id: string,
    title: string,
    values: number[],
    value: number,
    sign?: string,
    textPosition?: "bottom" | "right"
    changeValue: (value:number) => void
    onEndAcion?: () => void
}
 

class FormRangeValues extends React.Component<FormRangeValuesProps> {
    constructor(props:FormRangeValuesProps){
        super(props)

    }

    onChange(event:React.ChangeEvent<HTMLInputElement>){
        let innerIndex = Number(event.target.value);
        let currentValue = this.props.values[innerIndex];
        this.props.changeValue(currentValue);
    }

    render() { 
        const {sign = "%", textPosition = "bottom"} = this.props
        const innerValueIndex = this.props.values.findIndex(it => it == this.props.value);
        return (
            <>
                <label htmlFor={this.props.id}> {this.props.title}</label>
                <div className={`range-wrapper ${textPosition === "right" ? "right-text" : ""}`}>
                    <div className="">
                    <input 
                        id={this.props.id}
                        className="range-control" 
                        type="range" 
                        min={0} 
                        max={this.props.values.length-1} 
                        step={1} 
                        value={innerValueIndex}
                        onChange={(event)=>{this.onChange(event)}}
                        onMouseUp={this.props.onEndAcion}
                    />
                    </div>
                    <span>{this.props.value}{sign}</span>
                </div>
                
            </>
        );
    }
}
 
export default FormRangeValues;